const tableBody = document.getElementById("table-body");
const prevBtn = document.getElementById("prev-btn");
const nextBtn = document.getElementById("next-btn");
const paginationInfo = document.getElementById("pagination-info");

if (tableBody && prevBtn && nextBtn && paginationInfo) {
    let currentPage = 1;
    const rowsPerPage = 10;
    const rows = Array.from(tableBody.getElementsByTagName("tr"));
    const totalPages = Math.ceil(rows.length / rowsPerPage);
    
    let paginationEvent = new Event("pagination-update");
    
    function showPage(page) {
        
        tableBody.innerHTML = "";
        const start = (page - 1) * rowsPerPage;
        const end = start + rowsPerPage;
        
        rows.slice(start, end).forEach(row => tableBody.appendChild(row));
        
        paginationInfo.textContent = `${start + 1}-${Math.min(end, rows.length)} de ${rows.length}`;
        
        prevBtn.style.visibility = page === 1 ? "hidden" : "visible";
        nextBtn.style.visibility = page === totalPages ? "hidden" : "visible";
        
        document.dispatchEvent(paginationEvent);
    }

    prevBtn.addEventListener("click", function (event) {
        event.preventDefault();
        if (currentPage > 1) {
            currentPage--;
            showPage(currentPage);
        }
    });

    nextBtn.addEventListener("click", function (event) {
        event.preventDefault();
        if (currentPage < totalPages) {
            currentPage++;
            showPage(currentPage);
        }
    });

    showPage(currentPage);
}
